module.exports = __webpack_public_path__ + "static/visual-graph-8612c3764495c3bbfaf70545a15ff186.png";